import { Flex } from "@payping/web-components";
import { Outlet } from "react-router-dom";
import IpgDocument from "./Document/index";
import TokensSummery from "./Token/TokensSummery";

export const Developers = () => (
  <Flex className="tw-gap-4 lg:tw-gap-12" vertical>
    <TokensSummery />
    <IpgDocument />

    {/* < TokensList > */}
    <Outlet />
  </Flex>
);

export default Developers;
